<template>
    <el-dialog title="微信客资" :visible.sync="dialogVisible" custom-class="dialog" top="0vh" :before-close="handleClose">
        <i @click="handleClose" class="close-btn el-icon-circle-close"></i>
        <div class="eldialog-box">
            <div class="w200">
                <div v-if="Object.keys(memberWechatList.friend).length>0">
                    <div class="wechat-header">
                        <img class="avatar" :src="memberWechatList.friend.avatar" />
                        <div class="wechat-header-info">
                            <div class="wechat-header-detail">
                                <span class="title">昵称：</span>
                                <span class="text">{{memberWechatList.friend.wechat_nickname}}</span>
                            </div>
                            <div class="wechat-header-detail">
                                <span class="title">微信号：</span>
                                <span class="text">{{memberWechatList.friend.new_wechat_alias}}</span>
                            </div>
                        </div>
                    </div>
                    <div class="wechat-bd-info">
                        <div class="title">微信备注:</div>
                        <div class="text">{{memberWechatList.friend.remark}}</div>
                    </div>
                </div>

                <div class="wechat-header" v-else>
                    <img class="avatar" :src="userWechatList.staff.head_img" />
                    <div class="wechat-header-info">
                        <div class="wechat-header-detail">
                            <span class="title">员工：</span>
                            <span class="text">{{userWechatDetail.user.realname}}</span>
                        </div>
                        <div class="wechat-header-detail">
                            <span class="title">昵称：</span>
                            <span class="text">{{userWechatList.staff.nick_name}}</span>
                        </div>
                        <div class="wechat-header-detail">
                            <span class="title">微信号：</span>
                            <span class="text">{{userWechatList.staff.wechat_alias}}</span>
                        </div>
                    </div>
                    <div class="menu">
                        <div class="menuitem" v-for="(item, index) in menuItems" :key="index"
                            :class="{ischeck:index==activeIndex}" @click="changemenuItem(item,index)">
                            <i v-if="index==0" class="el-icon-chat-round"></i>
                            <i v-else class="el-icon-chat-dot-round"></i>{{item.title}}
                        </div>
                        <!-- <div class="menuitem" @click="changeCollapseItem(2)" :class="{ischeck:index==current}">
                            <i class="el-icon-chat-dot-round"></i>群聊
                        </div> -->

                    </div>
                </div>
            </div>
            <div class="w350">
                <div class="search-top">
                    <div v-if="type=='memberWechatList'">添加客户微信员工列表</div>
                    <el-input v-else placeholder="客资搜索" @clear="clearSearch" @keyup.native.enter="searchUser()"
                        clearable v-model="query.keyword" class="input-with-select">
                        <el-button slot="append" @click="searchUser" icon="el-icon-search"></el-button>
                    </el-input>
                </div>
                <div class="search-numbersbox" v-if="memberWechatList.staff.length>0">
                    <div class="search-list" v-for="(item,index) in memberWechatList.staff" :key="index"
                        @click="changeCollapseItem(item,index)" :class="{ischeck:index==current}">
                        <div class="search-info">
                            <div class="search-avatar"> <img class="avatar" :src="item.head_img" /></div>
                            <div class="search-contant">
                                <div class="title">{{item.nick_name}}</div>
                                <div class="tips">{{item.wx_alias}}</div>
                                <!-- <div class="tips">最近联系的时间：</div> -->
                            </div>
                        </div>
                    </div>
                </div>
                <div class="search-numbersbox" v-else>
                    <template v-if="getUserFriend.length>0">
                        <div class="search-list" v-for="(item,index) in getUserFriend" :key="index"
                            @click="changeUserWechatList(item,index)" :class="{ischeck:index==current}">
                            <div class="search-info">
                                <div class="search-avatar"> <img class="avatar" :src="item.avatar" /></div>
                                <div class="search-contant">
                                    <div class="title">{{item.wechat_nickname}}</div>
                                    <div class="tips">{{item.new_wechat_alias}}</div>
                                    <div class="tips" v-if="chatType==2">最近联系的时间：{{item.last_chat_time}}</div>
                                </div>
                            </div>
                        </div>
                    </template>
                    <div v-else class="notips">暂时没有</div>
                    <div class="more-btn" v-if="getUserFriend.length>0" v-show="isUserShow" @click="showView">查看更多</div>
                </div>
            </div>
            <div class="wechatmain">
                <wechat-main ref="wechatMain" :parent="_self"></wechat-main>
            </div>
        </div>
    </el-dialog>

</template>

<script>
import wechatMain from './wechat_main.vue';
// 初始参数
const query = {
    keyword: ''
};
export default {
    components: {
        wechatMain,
    },
    data() {
        let windowheight = window.innerHeight;
        return {
            query: Object.assign({}, query),
            dialogVisible: false,
            fullscree: true,
            windowheight: windowheight,
            current: 999,
            memberDetail: {
                user: {}
            },
            type: "",
            memberWechatList: {
                friend: {},
                staff: []
            },
            userWechatList: {
                friend: [],
                staff: {}
            },
            getUserFriend: [],
            memberWechat: {},
            userWechatDetail: {
                user: {}
            },
            staffId: "",
            searchPage: 1,
            isUserShow: false,
            menuItems: [{
                id: "1",
                title: "单聊"
            }, {
                id: "2",
                title: '群聊'
            }],
            activeIndex: "0",
            chatType: "1"
        };
    },
    created() {

    },
    methods: {
        changeCollapseItem(row, index) {
            let _this = this;
            _this.current = index;
            if (this.$refs['wechatMain']) {
                this.$refs['wechatMain'].showWechat(_this.memberWechat.wechat_id, row.wx_id, _this.type);
            } else {
                this.$nextTick(function () {
                    this.$refs['wechatMain'].showWechat(_this.memberWechat.wechat_id, row.wx_id, _this.type);
                })
            }
        },
        changemenuItem(row, index) {
            let _this = this;
            _this.activeIndex = index;
            _this.chatType = row.id;
            _this.clearSearch()
        },
        changeUserWechatList(row, index) {
            let _this = this;
            _this.$refs.wechatMain.ruleForm.keywords = '';
            _this.$refs.wechatMain.ruleForm.times = []
            _this.$refs.wechatMain.ruleForm.types = []
            _this.current = index;
            if (_this.$refs['wechatMain']) {
                _this.$refs['wechatMain'].showUersWechat(_this.userWechatDetail.wxid, row, _this.type);
            } else {
                _this.$nextTick(function () {
                    _this.$refs['wechatMain'].showUersWechat(_this.userWechatDetail.wxid, row, _this.type);
                })
            }
        },
        //
        // 客户微信被多个员工添加
        getMemberWechatList(wechat_id) {
            //获取表格列表
            let that = this;
            let url = '/api/customer.member/memberWechatList';
            let params = {
                friend_id: wechat_id,
            };
            this.$post(url, params).then(function (res) {
                if (res.code == 200) {
                    let data = res.data;
                    that.memberWechatList = data;
                    let row = that.memberWechatList.staff[0]
                    that.changeCollapseItem(row, 0)
                }
            });
        },
        showView() {
            let _this = this;
            _this.searchPage++
            _this.getUserWechatList();
        },
        clearSearch() {
            let _this = this;
            _this.getUserFriend = [];
            _this.searchPage = 1;
            _this.getUserWechatList();
        },
        // 员工添加多个客户微信
        getUserWechatList() {
            //获取表格列表
            let _this = this;
            _this.isUserShow = true;
            let url = '/api/customer.member/getUserWechatList';
            let params = {
                wx_alias: _this.userWechatDetail.wxid,
                limit: 15,
                page: _this.searchPage,
                type: _this.chatType
            };
            this.$post(url, params).then(function (res) {
                if (res.code == 200) {
                    let data = res.data;
                    _this.userWechatList.staff = data.staff;
                    _this.userWechatList = data;
                    _this.getUserFriend = _this.getUserFriend.concat(data.friend);
                    let row = _this.getUserFriend[0];
                    _this.changeUserWechatList(row, 0)
                    if (data.friend.length <= 0) {
                        _this.isUserShow = false
                    }

                }
            });
        },
        wechatShowDialog(row, type) {
            console.log(type)
            let _this = this;
            _this.dialogVisible = true;
            _this.type = type;
            _this.searchPage = 1;
            _this.getUserFriend = [];
            _this.query.keyword == '';
            _this.activeIndex = '0';
            _this.chatType = '1'
            _this.query = Object.assign({}, query);
            //客户微信被多个员工添加
            if (type == 'memberWechatList') {
                _this.memberDetail = row;
                _this.memberWechat = _this.memberDetail.wechat[0];
                _this.getMemberWechatList(_this.memberWechat.wechat_id)
            }
            //员工添加多个客户微信
            if (type == 'userWechatList') {
                _this.userWechatDetail = row;
                _this.userWechatList.friend = [];
                _this.userWechatList.staff = {};
                _this.$nextTick(() => {
                    _this.$refs.wechatMain.getMemberWechatLog = [];
                    _this.$refs.wechatMain.friends = {}
                })
                _this.getUserWechatList()
            }

        },

        //搜索客资
        searchUser() {
            //获取表格列表
            let _this = this;
            _this.isUserShow = false;
            let url = '/api/customer.member/getUserWechatList';
            let params = {
                wx_alias: _this.userWechatDetail.wxid,
                keyword: _this.query.keyword,
                limit: 15,
                page: 1,
                type: _this.chatType
            };
            this.$post(url, params).then(function (res) {
                if (res.code == 200) {
                    let data = res.data
                    _this.getUserFriend = [];
                    _this.getUserFriend = data.friend;
                    let row = data.friend[0];
                    _this.changeUserWechatList(row, 0)

                }
            });
        },
        handleClose(done) {
            this.$confirm('确认关闭？')
                .then(_ => {
                    this.dialogVisible = false
                })
                .catch(_ => { });
        }
    }
};
</script>
<style lang="less" scoped>
/deep/.dialog {
    width: 100%;
    height: 100vh;
    position: fixed;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
}
/deep/.el-dialog__body {
    margin: 0;
    padding: 0;
}
/deep/.el-input-group__append {
    padding: 0 10px 0 11px;
}

/deep/.el-dialog__header {
    display: none;
}

.close-btn {
    position: fixed;
    right: 20px;
    top: 20px;
    cursor: pointer;
    font-size: 22px;
}
.eldialog-box {
    width: 100%;
    height: 100vh;
    display: flex;
    overflow: hidden;
    .w200 {
        width: 200px;
        overflow: hidden;
        background: #4d4d4d;
        height: calc(100vh);
        max-width: 200px;
        min-width: 200px;
        width: 200px;
        flex: 0 0 200px;
        .wechat-header {
            padding: 20px 0;
            color: #fff;
            display: flex;
            flex-direction: column;
            align-items: center;
            .wechat-header-info {
                width: auto;
                padding-bottom: 20px;
                border-bottom: 4px solid #666;
                .wechat-header-detail {
                    display: flex;
                    align-items: center;
                    .title {
                        width: 60px;
                        text-align: right;
                        white-space: nowrap;
                        overflow: hidden;
                        display: inline-block;
                    }
                    .text {
                        max-width: 140px;
                        overflow: hidden;
                        display: inline-block;
                    }
                }
            }
            .menu {
                margin: 15px 0;
                width: 80%;
                .menuitem {
                    font-size: 16px;
                    font-weight: 600;
                    line-height: 40px;
                    width: 100%;
                    text-align: left;
                    color: #a5a5a5;
                    cursor: pointer;
                    i {
                        margin-right: 30px;
                    }
                }
                .ischeck {
                    color: white;
                }
            }
        }
        .wechat-bd-info {
            color: white;
            padding: 10px 20px;
            .title {
                color: #c5a9a9;
            }
        }
        .avatar {
            width: 88px;
            height: 88px;
            line-height: 88px;
            font-size: 18px;
            border-radius: 10px;
            margin-bottom: 20px;
        }
    }
    .w350 {
        width: 350px;
        position: relative;
        height: 100vh;
        overflow: hidden;
        border-right: 1px solid #cfcfcf;
        .search-top {
            padding: 18px 24px;
            border-bottom: 1px solid rgb(238, 238, 238);
            .search-numbersbox {
                width: 300px;
            }
        }
        .search-numbersbox {
            height: calc(100vh - 104px);
            overflow: auto;
            position: relative;
            .more-btn {
                position: fixed;
                bottom: 0;
                left: 200px;
                right: 0;
                text-align: center;
                cursor: pointer;
                height: 35px;
                line-height: 35px;
                width: 330px;
            }
            .search-list {
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: 12px 0;
                color: #000000d9;
                padding-left: 16px;
                cursor: pointer;
                border-bottom: 1px solid #f0f0f0;
                .search-info {
                    display: flex;
                    flex: 1;
                    align-items: flex-start;
                    max-width: 100%;
                    .search-avatar {
                        margin-right: 16px;
                        .avatar {
                            width: 44px;
                            height: 44px;
                            line-height: 44px;
                            font-size: 18px;
                            border-radius: 8px;
                        }
                    }
                    .search-contant {
                        flex: 1 0;
                        width: 0;
                        color: #000000d9;
                        .title {
                            margin-bottom: 4px;
                            color: #000000d9;
                            font-size: 14px;
                            line-height: 1.5715;
                            outline: none;
                        }
                        .tips {
                            color: #00000073;
                            font-size: 12px;
                            line-height: 1.5715;
                        }
                    }
                }
            }
            .ischeck {
                background: #f3f3f3;
            }
            .search-list:hover {
                background-color: #f3f3f3;
            }
        }
    }
}
.notips {
    text-align: center;
    line-height: 35px;
}
// flex: none，等同于 flex: 0 0 auto;
// flex: auto，等同于 flex: 1 1 auto;
// flex: 1，等同于 flex: 1 1 0%;
// flex: 0，等同于 flex 0 1 0%;
.wechatmain {
    flex: 1 1 0%;
}
</style>